import React from 'react';
// @ts-ignore
import fiftyThirteenIcon from '../../../../../assets/images/5013-Icon.png';
import airTestIcon from '../../../../../assets/images/AirTestIcon.png';

function CustomIcon({ moduleName }) {
  const icons = {
    '5013': fiftyThirteenIcon,
    'Air Test': airTestIcon,
  };
  return <img src={icons[moduleName]} width={20} />;
}

export default CustomIcon;
